module.exports = __webpack_public_path__ + "img/ic_info_secondary.5209a4e5.svg";